<template>
  <router-view />
</template>

<script>
export default {
  mounted: function () {
    if (window.localStorage.getItem('locale') !== null) {
      const userLang = window.localStorage.getItem('locale')
      this.$i18n.locale = userLang
    } else {
      const userLang = navigator.language || navigator.userLanguage
      this.$i18n.locale = userLang
    }
    if (window.localStorage.getItem('history') === null) {
      window.localStorage.setItem('history', '[]')
    }
  },
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
}
body {
  width: 100%;
  margin: 0px;
}
</style>
